export const MULTI_ROOM_DISCOUNT = 75;



// WEBPACK FOOTER //
// ./app/javascript/components/brief/components/BriefConstants.js